import { BROKEN_LINKS_CRAWLER } from 'root/src/shared/descriptions/endpoints/endpointIds'
import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema'

export default {
	[BROKEN_LINKS_CRAWLER]: {
		payloadSchema: cronJobPayloadSchema,
		isCron: true,
	},
}
